import { ERouteNames, ESearchResultTypes, ELocale } from '../types/enums';

export const DEFAULT_APP_COLOR = '#1d3998';
export const DEFAULT_BUTTON_COLOR = '#1d3998';
export const DEFAULT_BUTTON_TEXT_COLOR = '#ffffff';
export const DEFAULT_LINK_COLOR = '#1d3998';
export const DEFAULT_ACCOUNT_LOCALE = ELocale.CS;

export const MAX_DESCRIPTION_LENGTH = 1500;

export const MENU_LEVEL_THRESHOLD = 3;

export const LITE_SIDEBAR_SLUG = 'lite-sidebar';

export const JWT_TOKEN_ISSUER = 'munipolis.com';
export const JWT_GUEST_USER_ID = 0;
export const JWT_USER_SOURCE_GUEST = 'guest';
export const JWT_MUNIPOLIS_APP_MY_MR = 'MyMr';
export const JWT_GUEST_FIRSTNAME = 'guest';
export const JWT_GUEST_LASTNAME = 'guest';
export const JWT_AUDIENCE_MR_API = 'MrAPI';
export const JWT_AUDIENCE_ADMIN_API = 'AdminAPI';

export const SIDEBAR_FIXED_TOP_POSITION = 112;
export const SIDEBAR_FIXED_WIDTH_REDUCTION = 36;
export const SIDEBAR_FIXED_HEIGHT_REDUCTION = 130;
export const SIDEBAR_FIXED_LEFT_REDUCTION = 16;

export const MEILISEARCH_SEARCH_INDEX_NAME = 'globalSearch';

export const SEARCH_RESULT_TO_ROUTE_MAP = {
    [ESearchResultTypes.CUSTOM_PAGE]: {
        route: ERouteNames.CUSTOM_PAGE,
        paramMapping: {
            routeParam: 'slug',
            resultField: 'slug'
        }
    },
    [ESearchResultTypes.POST_DETAIL]: {
        route: ERouteNames.POST_DETAIL,
        paramMapping: {
            routeParam: 'id',
            resultField: 'originalId'
        }
    }
} as const;

export const SEARCH_RESULT_TYPE_LOCALE_KEY = {
    [ESearchResultTypes.CUSTOM_PAGE]: 'common.fulltext_search.result_type.customPage',
    [ESearchResultTypes.POST_DETAIL]: 'common.fulltext_search.result_type.posts',
} as const;

export const SUPPORTED_LOCALES = [
    ELocale.CS,
    ELocale.SK,
    ELocale.DE_DE,
    ELocale.HU_HU,
    ELocale.PL_PL,
    ELocale.EN
] as const;
